import axios from "axios";

/**
 * A separate axios instance for the public surface, with no auth interceptor.
 *
 * The shared client attaches a Firebase token whenever someone is signed in.
 * A therapist browsing the directory in another tab would then be sending
 * their credentials to endpoints that neither want nor check them — and the
 * public path would stop being anonymous in practice while looking anonymous
 * in the code.
 */
const publicClient = axios.create({
    baseURL: "/api",
    headers: { "Content-Type": "application/json" },
    paramsSerializer: { indexes: null },
});

export default publicClient;
